import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {useContext, useState} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {AutoComplete} from "./AutoComplete";
import {Opening} from "../../../../api/Openings";
import {useProjectId} from "../ProjectName";
import {makeIdOrder} from "../../quote/openings/MoveSelectedOpenings";

export function MoveSelectedOpenings(props: {
    ids: number[];
    onCancel: () => void;
    onDone: () => void;
}) {

    const project = useProjectId();
    const edit = useContext(EditContext);
    const reloadRef = useSyncedRef(edit.reload);

    const submit = useAsyncAction(async (input) => {
        await api.openings.reSequence(input)
        reloadRef.current();
        props.onDone();
    }, []);

    const [value, setValue] = useState<Opening|null>(null);

    const onSubmit = () => {
        if(!value) return;
        submit.callback({
            project: project,
            idOrder: makeIdOrder({
                selected: props.ids,
                startingSeqNumber: value?.seqNumber || 0,
                all: edit.dataRef.current.flatMap(v => v.rows),
            }),
        });
    };

    return (
        <Dialog2 open onClose={() => props.onCancel()} onEnterPress={onSubmit}>
            <DialogTitle>
                Move Selected Openings
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />

                <AutoComplete<Opening>
                    label="Select new starting sequence number"
                    search={async (s) => {
                        const list = edit.dataRef.current.flatMap(d => d.rows) as Opening[];

                        return list.filter(v => {
                            // if(v.name.toLowerCase().includes(s.toLowerCase())) return true;
                            if(v.seqNumber.toString().startsWith(s.toLowerCase())) return true;
                            return false;
                        });
                    }}
                    value={value}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={v => {
                        return v.seqNumber.toString()
                    }}
                    onSelect={setValue}
                />

            </DialogContent>
            <SmoothActionBar
                loading={submit.loading}
                error={submit.error}
                onCancel={() => props.onCancel()}
                onSubmit={onSubmit}
                actionName="Update"
                submitDisabled={!value}
            />
        </Dialog2>
    )
}